/* eslint-disable max-classes-per-file */
export const headers = (): [string, string][] => ([
    ['Authorization', imod.cms.scoreboards.authHeader],
    ['Content-Type', 'application/json'],
])

// tslint:disable:max-classes-per-file
export class InstanceSettingsApi {
    public static createGetRequest: (controlId: number) => ({ url: string, request: RequestInit }) = controlId => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/cms/scoreboards/admin/control/${controlId}/configuration`,
    })
}

export class MapDataApi {
    public static createGetRequest: (controlId: number) => ({ url: string, request: RequestInit }) = controlId => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/get?controlId=${controlId}`,
    })
}

export class LeaderboardDataApi {
    public static createGetRequest: (controlId: number) => ({ url: string, request: RequestInit }) = controlId => ({
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/transactions/getTotalsByDesignation?scoreboardSettingsId=${controlId}`,
        request: {
            responseType: 'json',
            method: 'POST',
            headers: headers(),
            cache: 'no-cache',
        },
    })
}
export class LeaderboardAmbassadorDataApi {
    public static createGetRequest: (initiativeIds: string, startdate: string, enddate: string) => ({ url: string, request: RequestInit }) = (initiativeIds, startdate, enddate) => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/getChallengeDetails/${initiativeIds}/${startdate}/${enddate}`,
    })
}


export class DonorRollDataApi {
    public static createGetRequest: (controlId: number, recordCount?: number) => ({ url: string, request: RequestInit }) = (controlId, recordCount = 0) => {
        let url = `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/get?controlId=${controlId}`
        if (recordCount) {
            url = `${url}&recordCount=${recordCount}`
        }
        return ({
            request: {
                responseType: 'json',
                method: 'GET',
                headers: headers(),
                cache: 'no-cache',
            },
            url,
        })
    }
}

export class AffiliationDataApi {
    public static createGetRequest: (controlId: number) => ({ url: string, request: RequestInit }) = controlId => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/get?controlId=${controlId}`,
    })
}

export class DashboardDataApi {
    public static createGetRequest: (controlId: number) => ({ url: string, request: RequestInit }) = controlId => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/get?controlId=${controlId}`,
    })
}

export class AmbassadorDataApi {
    public static createGetRequest: (controlId: number) => ({ url: string, request: RequestInit }) = controlId => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/get?controlId=${controlId}`,
    })
}
export class ViewChallengeDataApi {
    public static createGetRequest: (controlId: number) => ({ url: string, request: RequestInit }) = controlId => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/get?controlId=${controlId}`,
    })
}

export class ViewChallengeApi {
    public static createGetRequest: (challengeId: number, parentFormId: number, initiativeId: number) => ({ url: string, request: RequestInit }) = (challengeId, parentFormId, initiativeId) => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/getSingleChallengeDetails/${challengeId}/${parentFormId}/${initiativeId}`,
    })
    public static createAmbassadorGetRequest: (ambssadorId: number) => ({ url: string, request: RequestInit }) = (ambssadorId) => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/ambassador/getAmbasssadorProfile/${ambssadorId}`,
    })
}

const pageSize = 12
export class ChallengeDataApi {
    public static createGetRequest: (initiativeId: number, parentFormId: number, pageIndex: number) => ({ url: string, request: RequestInit }) = (initiativeId, parentFormId, pageIndex = 0) => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/getChallengeDetails/${initiativeId}/${parentFormId}/${pageIndex}/${pageSize}`,
    })
}

export class AmbassadorProfileApi {
    public static createGetRequest: (ambssadorId: number) => ({ url: string, request: RequestInit }) = (ambssadorId) => ({
        request: {
            responseType: 'json',
            method: 'GET',
            headers: headers(),
            cache: 'no-cache',
        },
        url: `${imod.cms.scoreboards.baseUrl}/apiservices/ambassador/getAmbasssadorProfile/${ambssadorId}`,
    })
}
export class ApiPollingTimeIntervalApi {
    public static createGetRequest: () => { url: string; request: RequestInit } =
        () => ({
            request: {
                responseType: "json",
                method: "GET",
                headers: headers(),
                cache: "no-cache",
            },
            url: `${imod.cms.scoreboards.baseUrl}/apiservices/data/scoreboards/getScoreboardApiPollingTimeIntervalInMs`,
        });
}
export class AfterSocialShareApi {
    public static createPostRequest: (postUrl: string) => ({ url: string, request: RequestInit }) = (postUrl) => ({
        request: {
            method: 'POST',
            headers: headers(),
            cache: 'no-cache',
        },
        url: postUrl
    })
}
